import { Button, makeStyles } from '@material-ui/core';
import { lightBlue } from '@material-ui/core/colors';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { univApiCall } from '../../albCommonModule';
import { getLodingStatus, getScheduleInfo, getTransferCount, shortWord } from '../../commonModule';
import { LinksTab } from '../common/commonParts';
import SnackMsg from '../common/SnackMsg';

const LICENSE_LIST = ["児童発達支援管理責任者", "理学療法士等", "保育士", "指導員", "送迎員"];

const useStyles = makeStyles({
  workShiftMake: {
    minWidth: 1080,
    maxWidth: 1512,
    marginTop: 80,
    marginLeft: 80,
    '& .row': {
      display: 'flex',
      borderBottom: '#ddd 1px solid',
      '& .title': {
        width: '8rem',
        position: 'sticky',
        left: 48,
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
      },
      '& .value': {
        width: '3%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        '& p': {
          margin: '0 auto',
          fontSize: '0.6rem',
          fontWeight: 'bold'
        }
      },
      '& .cell': {
        height: '2rem',
        boxSizing: 'border-box'

      },
      '& .header': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }
    },
    '& .buttonWrap': {
      position: 'fixed',
      right: 40,
      bottom: 20
    }
  }
});

export const WorkShiftLinksTab = () => {
  const menu = [
    { link: "/workshift", label: "シフト作成" },
    { link: "/workshift/setting", label: "設定" }
  ];

  return (<LinksTab menu={menu}/>)
}

const getDayStyle = (dateDt) => {
  const result = {};
  const day = new Date(dateDt.date).getDay();
  if(dateDt.holiday === 1) result.backgroundColor = "rgb(255, 241, 226)";
  else if(dateDt.holiday === 2) result.backgroundColor = "rgb(202,202,217)";
  else if(day === 1 || day === 3 || day === 5) result.backgroundColor = "#f5f5f5";

  return result;
}

const DateHeader = (props) => {
  const {dateList} = props;
  const dayStrList = ["日", "月", "火", "水", "木", "金", "土"];
  const nodes = dateList.map((dateDt, i) => {
    const date = new Date(dateDt.date);
    const dayStr = dayStrList[date.getDay()];
    return(
      <div key={i} className='header value cell'style={{...getDayStyle(dateDt)}} >
          <p style={{marginBottom: 2, fontSize: '0.8rem'}}>{String(date.getDate())}</p>
          <p style={{fontSize: '0.8rem'}}>{dayStr}</p>
      </div>
    )
  })

  return(
    <div className="row">
      <div className='title cell'></div>
      {nodes}
    </div>
  )
}

const ScheduleInfos = (props) => {
  const {scheduleInfo={}, transferInfo={}, dateList} = props;
  const nodes = {
    "利用数": [],
    "迎え人数": [],
    "迎え場所": [],
    "送り人数": [],
    "送り場所": []
  }
  dateList.forEach((dateDt, i) => {
    const dateObj = new Date(dateDt.date);
    const dDate = "D"
      + String(dateObj.getFullYear())
      + String(dateObj.getMonth()+1).padStart(2, '0')
      + String(dateObj.getDate()).padStart(2, '0');
    let riyoCnt = 0;
    let pickupList = 0;
    let pickupCnt = 0;
    let sendList = 0;
    let sendCnt = 0;
    if(scheduleInfo.didCounts && scheduleInfo.didCounts[dDate]){
      const didCount = scheduleInfo.didCounts[dDate];
      riyoCnt = didCount.schoolOffCnt + didCount.weekDayCnt;
    }
    if(transferInfo[dDate]){
      pickupList = Object.keys(transferInfo[dDate].pickup).reduce((result, x) => {
        if(!(x === "total" || x === "outofCount")) result += 1;
        return result;
      }, 0);
      pickupCnt = transferInfo[dDate].pickup.total;
      sendList = Object.keys(transferInfo[dDate].send).reduce((result, x) => {
        if(!(x === "total" || x === "outofCount")) result += 1;
        return result;
      }, 0);
      sendCnt = transferInfo[dDate].send.total;
    }
    nodes["利用数"].push(<div key={"riyo"+i} style={getDayStyle(dateDt)} className='value cell'><p>{String(riyoCnt)}</p></div>);
    nodes["迎え場所"].push(<div key={"puList"+i} style={getDayStyle(dateDt)} className='value cell'><p>{String(pickupList)}</p></div>);
    nodes["迎え人数"].push(<div key={"puCnt"+i} style={getDayStyle(dateDt)} className='value cell'><p>{String(pickupCnt)}</p></div>);
    nodes["送り場所"].push(<div key={"sendList"+i} style={getDayStyle(dateDt)} className='value cell'><p>{String(sendList)}</p></div>);
    nodes["送り人数"].push(<div key={"sendCnt"+i} style={getDayStyle(dateDt)} className='value cell'><p>{String(sendCnt)}</p></div>);
  })

  return(
    <>
    {Object.keys(nodes).map((nodeKey, i) => (
      <div key={"schInfo"+i} className="row">
        <div className='title cell'>{nodeKey}</div>
        {nodes[nodeKey]}
      </div>
    ))}
    </>
  )
}

const StaffShiftForm = (props) => {
  const {shiftDts, setShiftDts, staffs, dateList} = props;
  const staffFormNodes = staffs.map((staffDt, i) => {
    const name = staffDt.name;
    const nodesByDate = dateList.map((dateDt, j) => {
      const dateObj = new Date(dateDt.date);
      const dDate = "D"
        + String(dateObj.getFullYear())
        + String(dateObj.getMonth()+1).padStart(2, '0')
        + String(dateObj.getDate()).padStart(2, '0');
      const toWork = shiftDts[dDate] ?shiftDts[dDate][name] ?true :false :false;

      const handleClick = () => {
        const result = {...shiftDts};
        if(!result[dDate]) result[dDate] = {};
        if(result[dDate][staffDt.name]){
          delete result[dDate][staffDt.name];
        }else{
          result[dDate][staffDt.name] = {
            start: '09:00', end: '18:00', // start endは固定で。将来入力可とするかも
            license: staffDt.license,
            driver: staffDt.driver,
          };
        }
        if(!Object.keys(result[dDate]).length) delete result[dDate];
        setShiftDts({...result});
      }

      return(
        <div
          key={"ss"+j}
          style={getDayStyle(dateDt)}
          className='value cell'
          onClick={handleClick}
        >
          <p>{toWork ?"●" :""}</p>
        </div>
      )
    })

    return(
      <div key={i} className="row">
        <div className='title cell'>{name}</div>
        {nodesByDate}
      </div>
    )
  })

  return(
    <>
    {staffFormNodes}
    </>
  )
}

const PlacementRateInfo = (props) => {
  const {shiftDts, dateList, scheduleInfo} = props;
  const nodesByDate = dateList.map((dateDt, i) => {
    const dateObj = new Date(dateDt.date);
    const dDate = "D"
      + String(dateObj.getFullYear())
      + String(dateObj.getMonth()+1).padStart(2, '0')
      + String(dateObj.getDate()).padStart(2, '0');
    let riyoCnt = 0;
    if(scheduleInfo.didCounts && scheduleInfo.didCounts[dDate]){
      const didCount = scheduleInfo.didCounts[dDate];
      riyoCnt = didCount.schoolOffCnt + didCount.weekDayCnt;
    }
    let staffCnt = 0;
    if(shiftDts[dDate]){
      staffCnt = Object.values(shiftDts[dDate]).length;
    }
    const result = staffCnt ?String(riyoCnt/staffCnt) :"0";
    return(
      <div key={i} style={getDayStyle(dateDt)} className='value cell'>
        <p>{
          result.isInteger ?result :String(Math.round(result*10)/10)
        }</p>
      </div>
    )
  })

  return(
    <div className="row">
      <div className='title cell'>配置率</div>
      {nodesByDate}
    </div>
  )
}

const ShiftLicenseForm = (props) => {
  const {shiftDts, dateList} = props
  const licenseFormNodes = LICENSE_LIST.map((license, i) => {
    const nodesByDate = dateList.map((dateDt, j) => {
      const dateObj = new Date(dateDt.date);
      const dDate = "D"
        + String(dateObj.getFullYear())
        + String(dateObj.getMonth()+1).padStart(2, '0')
        + String(dateObj.getDate()).padStart(2, '0');
      const numOfLicense = (() => {
        let result = 0;
        const shiftDt = shiftDts[dDate] ?shiftDts[dDate] :{};
        Object.values(shiftDt).forEach(dt => {
          const licenseList = dt.license ?dt.license :[];
          if(licenseList.includes(license)) result += 1;
          if(license==="送迎員" && dt.driver) result += 1;
        });
        return String(result);
      })();
      return(<div key={"sld"+j} style={getDayStyle(dateDt)} className='value cell'><p>{numOfLicense}</p></div>)
    })
    return(
      <div key={"sl"+i}className="row">
        <div className='title cell'>{shortWord(license)}</div>
        {nodesByDate}
      </div>
    )
  })

  return(
    <>
    {licenseFormNodes}
    </>
  )
}

const WorkShiftMake = () => {
  const classes = useStyles();
  const allState = useSelector(state => state);
  const [originShiftDts, setOriginShiftDts] = useState(null);
  const [shiftDts, setShiftDts] = useState(null);
  const [snack, setSnack] = useState({});
  const loadingStatus = getLodingStatus(allState);
  const {com, stdDate, dateList, schedule, users, service, classroom} = allState;

  useEffect(() => {
    if(!loadingStatus.loaded) return;
    (async() => {
      const prms = {
        a: "fetchWorkshift",
        hid: com.hid,
        bid: com.bid,
        date: stdDate
      }
      const res = await univApiCall(prms, '', '', setSnack, "", "データの取得に失敗しました。");
      const data = res.data
        ?res.data.dt
          ?res.data.dt[0]
            ?res.data.dt[0].workshift ?res.data.dt[0].workshift :{}
            :{}
          :{}
        :{};
      setOriginShiftDts({...JSON.parse(JSON.stringify(data))});
      setShiftDts({...data});
    })();
  }, []);

  if(!(loadingStatus.loaded && shiftDts)) return null;

  const sendShiftDts = async() => {
    const sendDts = {...shiftDts};
    Object.keys(sendDts).forEach(dDate => {
      Object.keys(sendDts[dDate]).forEach(staffName => {
        const license = sendDts[dDate][staffName].license;
        let index = 5;
        if(license.includes("児童発達支援管理責任者")) index = 0;
        else if(license.includes("看護士等")) index = 1;
        else if(license.includes("理学療法士等")) index = 2;
        else if(license.includes("保育士等")) index = 3;
        else if(license.includes("児童指導員等")) index = 4;
        sendDts[dDate][staffName].index = index;
      });
    });
    const prms = {
      a: "sendWorkshift",
      hid: com.hid,
      bid: com.bid,
      date: stdDate,
      workshift: JSON.stringify(sendDts)
    }
    const res = await univApiCall(prms, '', '', setSnack, "書き込み完了", "書き込みに失敗しました。");
    if(res.data.result) setOriginShiftDts({...shiftDts});
  }

  const staffs = com.ext ?com.ext.staffs ?com.ext.staffs :[] :[];
  const scheduleInfo = getScheduleInfo(schedule, service, users, classroom);
  const transferInfo = getTransferCount(schedule);
  const riyoInfosPrms = {scheduleInfo, transferInfo, dateList};
  const staffShiftFormPrms = {shiftDts, setShiftDts, staffs, dateList};
  const placementRateInfoPrms = {shiftDts, dateList, scheduleInfo}
  const shiftLicenseFormPrms = {shiftDts, dateList};
  return(
    <>
    <WorkShiftLinksTab />
    <div>シフト作成テスト</div>
    <div className={classes.workShiftMake}>
      <DateHeader dateList={dateList}/>
      <ScheduleInfos {...riyoInfosPrms} />
      <StaffShiftForm {...staffShiftFormPrms}/>
      <PlacementRateInfo {...placementRateInfoPrms}/>
      <ShiftLicenseForm {...shiftLicenseFormPrms}/>
      <div className='buttonWrap'>
        <Button
          variant='contained'
          style={{marginRight: 8, backgroundColor: lightBlue[800], color: '#fff'}}
          onClick={() => setShiftDts({...JSON.parse(JSON.stringify(originShiftDts))})}
        >
          キャンセル
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={sendShiftDts}
        >
          書き込み
        </Button>
      </div>
    </div>
    <SnackMsg {...snack}/>
    </>
  )
}
export default WorkShiftMake